import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Syllabus } from 'src/app/_models/syllabus';
import { SyllabusService } from '../../../_services/syllabus.service';
declare var $ : any;
@Component({
  selector: 'app-admin-syllabus-show',
  templateUrl: './admin-syllabus-show.component.html',
  styleUrls: ['./admin-syllabus-show.component.css']
})
export class AdminSyllabusShowComponent implements OnInit {
  syllabus= new Syllabus()
  loading=false
  constructor(
    private route:ActivatedRoute,
    private syllabusService:SyllabusService
  ) { }

  ngOnInit(): void {
    this.loading=true
    this.route.params.subscribe(
    params=>{
    let syllabusId=params['server_syllabus_id']
    this.syllabusService.getSyllabusById(syllabusId).subscribe(
      x=>{
        this.syllabus=x
        this.loading=false
      }
    )
  }
)
}
testSyllabus(){
  this.syllabusService.testSyllabus(this.syllabus.server_syllabus_id).subscribe(
    x=>{
      this.loading=false
    }
  )

}
  addNewTopicPopUp(){
    $("#addNewTopicModal").modal("show");
  }
  reloadTopic(){
    this.syllabusService.getSyllabusById(this.syllabus.server_syllabus_id).subscribe(
      xx=>{
        this.syllabus=xx
      }
    )
  }

}
